export { default } from './locale-modal';
export { localeModalHandler } from './locale-modal.handler';
export type { LocaleModalProperties } from './locale-modal.types';
